<script>
    import { SplitTest } from "svelte-split-testing";
    import { add_param_of_interest, logEvent } from "./utils/logs";

    export let key;
    export let variants;

    const track_view = (event) => {
        add_param_of_interest(key, event.variant);
        logEvent(`experiment_view_${key}`, {
            variant: event.variant
        });
    };

</script>

<SplitTest {key} {variants} let:variant onView={track_view}>
    <slot {variant} />
</SplitTest>
